export function chargeWentThrough(response) {
    return !!(response && (response.success === true || response.payment_processed === true));
}
